'use client';
import Image from 'next/image';
import { IcChevronRight, Typography, theme } from '@bgzt/ui';
import { AUTHORIZED_SHOPS, ShopId } from '~/constants';
import mandarakeLogoImage from '~/public/assets/images/mandarake_logo_image_4x.webp';
import ragTagLogoImage from '~/public/assets/images/ragtag_logo_image_4x.webp';

import styles from './ProductShopEntryBanner.module.css';
import { getShopInfo } from '~/utils/shop-service';
import { LinkByEnvironment } from '~/components';

type Props = {
  shopId?: string;
};
export const ProductShopEntryBanner = ({ shopId }: Props) => {
  if (!shopId) {
    return null;
  }

  const SHOP_LOGO_IMAGE = {
    [AUTHORIZED_SHOPS.mandarake.id]: mandarakeLogoImage,
    [AUTHORIZED_SHOPS.ragTag.id]: ragTagLogoImage,
  };

  const SHOP_DESCRIPTION = {
    [AUTHORIZED_SHOPS.mandarake.id]: '일본 최대 서브컬쳐 편집샵, 만다라케 상품입니다',
    [AUTHORIZED_SHOPS.ragTag.id]: '일본 빈티지/셀렉트 샵, 래그태그 상품입니다',
  };

  const HighlightedText = ({ text, highlightedWord }: { text: string; highlightedWord: string }) => {
    const parts = text.split(new RegExp(`(${highlightedWord})`));

    return (
      <>
        {parts.map((part, index) =>
          part === highlightedWord ? (
            <Typography key={index} variant={'C1'} color={'gray-900'} as="span">
              {part}
            </Typography>
          ) : (
            <span key={index}>{part}</span>
          ),
        )}
      </>
    );
  };

  return (
    <LinkByEnvironment href={`/shop/${shopId}`} target="_blank">
      <div className={styles.container}>
        <div className={styles.content}>
          <Image
            src={SHOP_LOGO_IMAGE[shopId as ShopId]}
            alt={`${getShopInfo(shopId as ShopId).shopNameKor} 로고`}
            width={28}
            height={28}
            unoptimized
            className={styles.logo}
          />
          <Typography variant={'L10'} color={'gray-800'}>
            <HighlightedText
              text={SHOP_DESCRIPTION[shopId as ShopId]}
              highlightedWord={getShopInfo(shopId as ShopId).shopNameKor}
            />
          </Typography>
        </div>
        <IcChevronRight size={12} fill={theme.colors['gray-500']} />
      </div>
    </LinkByEnvironment>
  );
};
